<label class="switch">
  <input type="checkbox" checked [formControl]="selected">
  <span class="slider round"></span>
</label>
